
  <div class="modal-content modal-content-width">
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px padding-right-15px">
        <div class="row">
          <div class="col-md-8">
            Activity Search
          </div>
          <div class="col-md-4">
            <button type="button" class="close" data-dismiss="modal"
                    (click)="activeModal.dismiss('Cross click')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        

        

      </div>
     
      <div class="modal-body padding-top-0px counselling-modal">

      
            <div class="row margin-top-10 margin-bottom-10px margin-left-10px">
              <div class="col-md-5">
                <input type="text" class="form-control" placeholder="Search by Name,Gender,Phone Number" (input)="criteriaChange($event.target.value)">
                <!--<search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>-->
              </div>
              
            
              
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="card">
                  <div class="card-body padding-top-0px padding-left-0px padding-right-0px padding-bottom-0px">
                    <div class="table-component">
                      <div class="table-responsive overflow-x">


                        <table class="table table-striped margin-left-zero "
                               cols="auto,2*,*,*,*,*,*,*">

                          <thead class="">
                            <tr>
                              <th></th>
                              <th class="padding-left-0px">
                               Activity Type
                              </th>
                              <!--<th class="text-align-center">Day</th>-->

                              <th class="">
                                Applicable To
                              </th>
                              <th class="">
                                ActivityDescription
                              </th>
                              <!--<th class="text-align-center">Start Time</th>-->
                              <th class="">
                             Service Name
                              </th>

                              <!--<th class="">
              Prime Relation
            </th>-->

                              <th class="">
                                Remarks
                              </th>
                            
                             



                            </tr>
                          </thead>

                          <tbody class="table-body">
                            <tr *ngFor="let l of CurrentIvfPlanActivityTemplateController">
                             <td><button type="button" class="btn font-size-13px actions-btn-prime" (click)="passback(l)">Select</button></td>
                              <td class="td-padding "> <a (click)="ViewPatientDetails(l)" class="nav-link-hand">{{l.ActivityType}}</a>  </td>
                              <!--<td class="td-padding text-align-center">Mon</td>-->
                              <td class="">

                                {{l.ApplicableTo}}
                              </td>
                              <td class="  ">{{l.ActivityDescription}}</td>
                              <!--<td class="td-padding text-align-center"></td>-->
                              <td class="padding-right-0px padding-left-0px">{{l.ServiceName}}</td>
                              <!--<td class="  ">{{l.PrimeRelation}}</td>-->

                              <td class="">{{l.Remarks}}</td>
                             


                             



                            </tr>

                          </tbody>

                        </table>
                      </div>
                    </div>
                  </div>
                </div>
               
              </div>
            </div>


      </div>
        <div class="modal-footer padding-top-10px padding-bottom-10px">

          <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3" (click)="activeModal.close('Close click')">Cancel</button>
         
        </div>
     
    </div>
  </div>
